import React from "react";
import {EventBus} from "../util/EventBus";
import reservationImg from "../assets/img/icon_reservation.svg";
import productsImg from "../assets/img/icon_menu.svg";
import takeAwayImg from "../assets/img/icon_pickup_menu.svg";
import {PATH} from "../routes/routes.js";
import * as StorageService from "../services/StorageService";
import {LOCALSTORAGE_ITEMS, ORDER_PLACE, USER_TYPES} from "../util/Constants";
import {useNavigate} from "react-router";
import * as ClientConfig from "../config/ClientConfig";
import {getCampaignTitle} from "../util/common";
import {getActiveOrderHandler} from "../handlers/HandlerProducts";

function CampaignCard(props) {
    const navigateTo = useNavigate();
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const isBarPickup = shopDetails ? (typeof shopDetails.merchantConfig.barPickup !== "undefined" ? shopDetails.merchantConfig.barPickup : null) : false;
    const isTableDelivery = shopDetails ? (typeof shopDetails.merchantConfig.tableDelivery !== "undefined" ? shopDetails.merchantConfig.tableDelivery : null) : false;
    const userType = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TYPE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TYPE) : null;
    const onCampaignClick = () => {
        if (props.isLinkCampaign) {
            handleClickOnLinkCampaign();
        }else{
            if ((userType === USER_TYPES.ANONYMOUS || userType === null)) {
                window.open(ClientConfig.URL_RESOURCE_SERVER + "/" + props.campaign?.pageLink, "_self", "noopener,noreferrer");
            }else if (userType === USER_TYPES.VERIFIED && userType !== null){
                window.open(ClientConfig.URL_RESOURCE_SERVER + "/" + props.campaign?.pageLink, "_self", "noopener,noreferrer");
            }else{
                EventBus.dispatch("accessingOnlyInAppCampaign");
            }
        }
    }

    const handleClickOnLinkCampaign = () => {
        const url = props.campaign?.link?.url;
        if (url?.startsWith("zoniz://")) {
            if (url?.indexOf("reservation")> 1) {
                navigateTo(PATH.ALL_RESERVATIONS)

            }else if (url?.indexOf("products")> 1) {
                StorageService.removeItem(LOCALSTORAGE_ITEMS.ALL_CAMPAIGNS);
             if (isBarPickup && isTableDelivery) {
                 const tableFromStorage = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE);
                 if (tableFromStorage === null) {
                     getActiveOrderHandler().then(response=>{
                         const activeOrder = response.data.activeOrder;
                         if (!response.data.error && activeOrder) {
                             StorageService.setItem(LOCALSTORAGE_ITEMS.USER_TABLE, activeOrder.table);
                             navigateTo(PATH.ALL_PRODUCTS);
                         }else{
                             props.openModal();
                         }
                     });
                 }else{
                     navigateTo(PATH.ALL_PRODUCTS);
                 }
                }else if (isBarPickup) {
                    StorageService.setItem(LOCALSTORAGE_ITEMS.ORDER_PLACE, ORDER_PLACE.BAR);
                    navigateTo(PATH.ALL_PRODUCTS);
                }else if (isTableDelivery) {
                    navigateTo(PATH.ALL_PRODUCTS);
                    StorageService.setItem(LOCALSTORAGE_ITEMS.ORDER_PLACE, ORDER_PLACE.TABLE);
                }else{
                 navigateTo({
                     pathname:  PATH.ALL_PRODUCTS,
                     search: "?readonly=true"
                 });
                    StorageService.setItem(LOCALSTORAGE_ITEMS.ORDER_PLACE, ORDER_PLACE.NOT_FOUND);
                }

            }else if (url?.indexOf("takeaway")> 1) {
                StorageService.setItem(LOCALSTORAGE_ITEMS.ORDER_PLACE, ORDER_PLACE.TAKEAWAY);
                navigateTo(PATH.TAKEAWAY);
            }
        }else{
            window.open(url, '_blank');
        }
    }



    const getIconForLinkCampaign = () => {

        const url = props.campaign.link?.url;
        if (url?.startsWith("zoniz://")) {
            if (url?.indexOf("reservation")> 1) {
               return reservationImg;
            }else if (url.indexOf("products")> 1) {
                return productsImg;
            }else if (url.indexOf("takeaway")> 1) {
                return takeAwayImg;
            }
        }else{
           return null;
        }
    }

    
    return (
        <>
        <div onClick={onCampaignClick}
            style={{backgroundImage: "url(" + props.campaign.imageLink + ")"}}
            className="campaign-card">
            <div className="icon">
                {props.isLinkCampaign?
                    getIconForLinkCampaign()!==null &&
                    <img alt="link icon" src={getIconForLinkCampaign()}/>
                    :null}
            </div>

            <div className="campaign-title">
                <div className="blurry-bg"></div>
                <div className="title">                    
                    {getCampaignTitle(props.campaign)}
                </div>
            </div>
        </div>
        </>
    );
}



export default CampaignCard;
